import React, { useState, useEffect } from "react";
import { useTheme } from "../config/ThemeContext";

const VideoChallengePanel = ({
  team,
  currentSet,
  challengeOK,
  challengeNOK,
  matchId,
  socket,
  onClose,
  teamName
}) => {
  const [result, setResult] = useState(null); // "OK" or "NOK"
  const theme = useTheme();
  const confirmChallenge = () => {
    if (!result || !socket) return;

    socket.emit("challenge", {
      matchId,
      currentSet,
      team,
      result // "OK" or "NOK"
    });

    onClose();
  };
    // Add ESC key to close panel
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

   return (
    <div className="max-w-xl mx-auto mt-6 bg-white border rounded-md shadow p-6">
      <h3 className="text-xl font-semibold mb-3 text-center text-gray-800">
        Video Challenge Requested by {teamName}
      </h3>

      <p className="text-center font-medium text-sm mb-6">
        Challenge record: ✅ <span className="font-bold">{challengeOK}</span> / ❌{" "}
        <span className="font-bold">{challengeNOK}</span>
      </p>

      {/* Buttons */}
      <div className="flex justify-center gap-6 mb-6">
        <button
          className={`px-4 py-2 rounded border ${theme.state.success.hover} ${
            result === "OK" ? "ring-2 ring-emerald-400 bg-green-300" : ""
          }`}
          onClick={() => setResult("OK")}
        >
          ✅ Challenge Successful
        </button>

        <button
          className={`px-4 py-2 rounded border  ${theme.state.danger.hover} ${
            result === "NOK" ? "ring-2 ring-red-400 bg-red-300" : ""
          }`}
          onClick={() => setResult("NOK")}
        >
          ❌ Challenge Failed
        </button>
      </div>

      {/* Footer Actions */}
      <div className="flex justify-end gap-4">
        <button
          onClick={confirmChallenge}
          disabled={!result}
		   className={`${theme.buttons.primary} focus:outline-none`}
        >
          Submit
        </button>
        <button
          onClick={onClose}
          className={`${theme.buttons.secondary} focus:outline-none`}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default VideoChallengePanel;